/**
 * Schema for a component property.
 * Defines the type, name, and default value of a configurable property.
 */
export type PropertySchema =
  | BooleanProperty
  | StringProperty
  | NumberProperty
  | EnumProperty;

export interface BooleanProperty {
  readonly type: 'boolean';
  readonly name: string;
  readonly defaultValue: boolean;
  readonly description?: string;
}

export interface StringProperty {
  readonly type: 'string';
  readonly name: string;
  readonly defaultValue: string;
  readonly description?: string;
  /** If true, render as multiline textarea */
  readonly multiline?: boolean;
}

export interface NumberProperty {
  readonly type: 'number';
  readonly name: string;
  readonly defaultValue: number;
  readonly description?: string;
  readonly min?: number;
  readonly max?: number;
  readonly step?: number;
}

export interface EnumProperty {
  readonly type: 'enum';
  readonly name: string;
  readonly defaultValue: string;
  readonly description?: string;
  readonly options: readonly string[];
}

/**
 * Gets the default values for a list of property schemas.
 */
export function getDefaultPropertyValues(properties: readonly PropertySchema[]): Record<string, unknown> {
  const values: Record<string, unknown> = {};
  for (const prop of properties) {
    values[prop.name] = prop.defaultValue;
  }
  return values;
}
